<template>
	<div class="exp-flex">
		<label id="hideinlaptop" class="exp-mob-heading d-flex align-items-center">
			Expertise Level -
			<h3
				class="ml-3 text-capitalize"
				:class="
					sliderValue == 0
						? 'text-yellow'
						: sliderValue == 1
						? 'text-orange'
						: sliderValue == 2
						? 'text-green'
						: sliderValue == 3
						? 'text-blue'
						: ''
				"
			>
				{{ inputData }}
			</h3>
		</label>
		<div id="hideinmobile">
			<div class="teams-label-font">
				Expertise level<span class="asterik">&nbsp;*</span>
			</div>
			<h3
				class="text-capitalize"
				:class="
					sliderValue == 0
						? 'text-yellow'
						: sliderValue == 1
						? 'text-orange'
						: sliderValue == 2
						? 'text-green'
						: sliderValue == 3
						? 'text-blue'
						: ''
				"
			>
				{{ inputData }}
			</h3>
		</div>
		<div class="slider-container position-relative">
			<input
				type="range"
				min="0"
				max="3"
				v-model="sliderValue"
				class="slider"
				:class="sliderClass"
				step="1"
				@input="handleInput"
				@click="handleSliderClick"
				@touchend="handleSliderClick"
			/>
			<div class="exp-line exp-line-1"></div>
			<div class="exp-line exp-line-2"></div>
			<div class="exp-line exp-line-3"></div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sliderValue: -1,
			inputData: "",
			levels: [],
		};
	},
	props: {
		noLabel: Boolean,
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		fieldType: String,
		options: Array,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},

	computed: {
		sliderClass() {
			return this.sliderValue == 0
				? "slider-yellow thumb-yellow"
				: this.sliderValue == 1
				? "slider-orange thumb-orange"
				: this.sliderValue == 2
				? "slider-green thumb-green"
				: this.sliderValue == 3
				? "slider-blue thumb-blue"
				: "slider-gray thumb-gray";
		},
	},
	watch: {
		vmodel(newValue) {
			this.inputData = this.levels.find((item) => item === newValue);
			this.sliderValue = this.levels.indexOf(this.inputData);
			this.$emit("select-value", this.inputData);
		},
		options(newValue, oldValue) {
			if (newValue != oldValue) {
				this.options = newValue;
				this.levels = this.options
					.map((item) => item.key)
					.filter((key) => key != null);
			}
		},
		inputData(newVal){
			this.sliderValue = this.levels.indexOf(this.inputData);
		}
	},
	created() {
		this.levels = this.options
			.map((item) => item.key)
			.filter((key) => key != null);
		if (this.vmodel) {
			this.inputData = this.levels.find((item) => item === this.vmodel);
			this.$emit("select-value", this.inputData);
		}
	},
	methods: {
		handleSliderClick(event) {
			if (this.sliderValue == -1) {
				this.sliderValue = 0;
				this.inputData = this.levels[this.sliderValue];
				this.$emit("select-value", this.inputData);
			}
			this.setValue();
		},
		handleInput() {
			console.log(this.levels, this.sliderValue);

			this.inputData = this.levels[this.sliderValue];
			this.$emit("select-value", this.inputData);
		},
		setValue() {
			console.log("sdsjd");
			console.log(
				this.sliderValue,
				"this.sliderValuethis.sliderValuethis.sliderValue"
			);
			if (this.sliderValue == -1) {
				this.sliderValue = 0;
				this.inputData = this.levels[this.sliderValue];
				this.$emit("select-value", this.inputData);
			}
		},
	},
};
</script>

<style scoped>
.slider-container {
	width: 71%;
	text-align: center;
	position: relative;
}
@media (max-width: 1028px) {
	.slider-container {
		width: 100%;
	}
	.slider {
		border-radius: 4px;
	}
	.slider::-webkit-slider-thumb {
		border-radius: 4px;
	}
}

/* Custom slider styles */
.slider {
	width: 100%;
	height: 37px; /* Set the slider height */
	-webkit-appearance: none; /* Remove default styling on webkit browsers (Chrome, Safari) */
	border-radius: 8px;
	outline: none;
	padding: 0;
	margin: 0;
}

/* Style the slider thumb */
.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	height: 36px;
	width: 25%; /* Thumb size adjusted to fit better */
	cursor: pointer;
	border-radius: 8px;
}

/* Style for Firefox */
.slider::-moz-range-thumb {
	height: 36px;
	width: 25%; /* Thumb size adjusted */
	cursor: pointer;
}

/* Add vertical lines between the parts */
.exp-line {
	background-color: #8c8c8c;
	width: 1px;
	height: 15px; /* Adjust the height for line visibility */
	position: absolute;
	top: 10px;
	flex-shrink: 0;
}
.exp-line-1 {
	left: 25%;
}
.exp-line-2 {
	left: 50%;
}
.exp-line-3 {
	left: 75%;
}

.slider-value {
	margin-top: 10px;
}

.slider-yellow {
	background: #f7e19a;
}

.slider-orange {
	background: #f0ce9d;
}

.slider-green {
	background: #9bd5b9;
}

.slider-blue {
	background: #20639b73;
}

.slider-gray {
	background: #dae5ee;
}

.text-yellow {
	color: #f9c82b;
}
.text-orange {
	color: #f9c82b;
}
.text-green {
	color: #2aa869;
}

/* Thumb color styles */
.thumb-yellow::-webkit-slider-thumb {
	background: #f9c82b;
}
.thumb-yellow::-moz-range-thumb {
	background: #f9c82b;
}

.thumb-orange::-webkit-slider-thumb {
	background: #e99e32;
}

.thumb-orange::-moz-range-thumb {
	background: #e99e32;
}

.thumb-green::-webkit-slider-thumb {
	background: #2aa869;
}

.thumb-green::-moz-range-thumb {
	background: #2aa869;
}

.thumb-blue::-webkit-slider-thumb {
	background: #1a5e8d;
}

.thumb-blue::-moz-range-thumb {
	background: #1a5e8d;
}
.thumb-gray::-webkit-slider-thumb {
	background: #b7ccde;
}

.thumb-gray::-moz-range-thumb {
	background: #b7ccde;
}

.exp-mob-heading {
	font-family: "Lato", sans-serif;
	font-size: 13px;
	font-weight: 400;
	color: #667085;
}

h3 {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 600;
	margin-bottom: 0;
}

@media (min-width: 1029px) {
	.exp-flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.exp-parent {
		width: 65%;
	}
	h3 {
		font-size: 11px;
	}
}
</style>
